import { put } from 'redux-saga/effects';
import { getShowPagesByShow } from '../../api/showPageAPI';
import * as types from './showPageActionTypes';

export function* showPageSaga() {
  try {
    const pages = yield getShowPagesByShow();
    if (pages && pages.error) {
      yield put({
        type: types.GET_SHOW_PAGE_ERROR,
        error: pages.error,
      });
    } else {
      yield put({
        type: types.GET_SHOW_PAGE_SUCCESS,
        pages,
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_SHOW_PAGE_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/showPage/showPageSaga.js